import { Injectable, signal, WritableSignal } from '@angular/core';

export interface EmojiPanelRef {
  closeBySync(): void;
}

@Injectable({ providedIn: 'root' })
export class EmojiPanelSyncService {
  private readonly activePanel: WritableSignal<EmojiPanelRef | null> = signal<EmojiPanelRef | null>(null);

  setActive(panel: EmojiPanelRef): void {
    const current: EmojiPanelRef | null = this.activePanel();
    if (current === panel) return;
    current?.closeBySync();
    this.activePanel.set(panel);
  }

  clearIfActive(panel: EmojiPanelRef): void {
    if (this.activePanel() === panel) {
      this.activePanel.set(null);
    }
  }

  closeActive(): void {
    const current: EmojiPanelRef | null = this.activePanel();
    current?.closeBySync();
    this.activePanel.set(null);
  }
}
